interface NotFoundPageProps {
  message?: string
}

export default function NotFoundPage({ message }: NotFoundPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-6">
        <div className="mb-6">
          <i className="fa-solid fa-folder-open text-6xl text-gray-300"></i>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Portfolio Not Found
        </h1>
        <p className="text-gray-600 mb-6">
          {message || "The portfolio you're looking for doesn't exist or has been removed."}
        </p>
        <a 
          href="https://learnplace.ai" 
          className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors"
        >
          <i className="fa-solid fa-arrow-left"></i>
          Go to Learn Place
        </a>
      </div>
    </div>
  )
}
